<script>
    import {range, extent, min, scaleQuantize, schemeBuPu, schemeOranges, scaleSequentialSymlog, interpolateInferno, interpolateYlGnBu, interpolateBuPu, quantize, interpolate} from "d3";
    // export let country;
    // export let hexesClean;
    export let numTicks;
    // export let margin;
    export let colorVar;
    export let darkMode;
    export let mainBgColor;
    export let mainDrawColor;
    export let accessMax;
    // console.log("accessMax from leg", accessMax)


    let width = 210
    let margin = ({ right: 20, left: 20, top:8})

    let legendWidth = width - margin.right - margin.left
    let legendSvgHeight = 45
    let extentAccess = [100, accessMax]
    let extentPop = [0,2000]
    let inferno = ["#000004","#010005","#010106","#010108","#02010a","#02020c","#02020e","#030210","#040312","#040314","#050417","#060419","#07051b","#08051d","#09061f","#0a0722","#0b0724","#0c0826","#0d0829","#0e092b","#10092d","#110a30","#120a32","#140b34","#150b37","#160b39","#180c3c","#190c3e","#1b0c41","#1c0c43","#1e0c45","#1f0c48","#210c4a","#230c4c","#240c4f","#260c51","#280b53","#290b55","#2b0b57","#2d0b59","#2f0a5b","#310a5c","#320a5e","#340a5f","#360961","#380962","#390963","#3b0964","#3d0965","#3e0966","#400a67","#420a68","#440a68","#450a69","#470b6a","#490b6a","#4a0c6b","#4c0c6b","#4d0d6c","#4f0d6c","#510e6c","#520e6d","#540f6d","#550f6d","#57106e","#59106e","#5a116e","#5c126e","#5d126e","#5f136e","#61136e","#62146e","#64156e","#65156e","#67166e","#69166e","#6a176e","#6c186e","#6d186e","#6f196e","#71196e","#721a6e","#741a6e","#751b6e","#771c6d","#781c6d","#7a1d6d","#7c1d6d","#7d1e6d","#7f1e6c","#801f6c","#82206c","#84206b","#85216b","#87216b","#88226a","#8a226a","#8c2369","#8d2369","#8f2469","#902568","#922568","#932667","#952667","#972766","#982766","#9a2865","#9b2964","#9d2964","#9f2a63","#a02a63","#a22b62","#a32c61","#a52c60","#a62d60","#a82e5f","#a92e5e","#ab2f5e","#ad305d","#ae305c","#b0315b","#b1325a","#b3325a","#b43359","#b63458","#b73557","#b93556","#ba3655","#bc3754","#bd3853","#bf3952","#c03a51","#c13a50","#c33b4f","#c43c4e","#c63d4d","#c73e4c","#c83f4b","#ca404a","#cb4149","#cc4248","#ce4347","#cf4446","#d04545","#d24644","#d34743","#d44842","#d54a41","#d74b3f","#d84c3e","#d94d3d","#da4e3c","#db503b","#dd513a","#de5238","#df5337","#e05536","#e15635","#e25734","#e35933","#e45a31","#e55c30","#e65d2f","#e75e2e","#e8602d","#e9612b","#ea632a","#eb6429","#eb6628","#ec6726","#ed6925","#ee6a24","#ef6c23","#ef6e21","#f06f20","#f1711f","#f1731d","#f2741c","#f3761b","#f37819","#f47918","#f57b17","#f57d15","#f67e14","#f68013","#f78212","#f78410","#f8850f","#f8870e","#f8890c","#f98b0b","#f98c0a","#f98e09","#fa9008","#fa9207","#fa9407","#fb9606","#fb9706","#fb9906","#fb9b06","#fb9d07","#fc9f07","#fca108","#fca309","#fca50a","#fca60c","#fca80d","#fcaa0f","#fcac11","#fcae12","#fcb014","#fcb216","#fcb418","#fbb61a","#fbb81d","#fbba1f","#fbbc21","#fbbe23","#fac026","#fac228","#fac42a","#fac62d","#f9c72f","#f9c932","#f9cb35","#f8cd37","#f8cf3a","#f7d13d","#f7d340","#f6d543","#f6d746","#f5d949","#f5db4c","#f4dd4f","#f4df53","#f4e156","#f3e35a","#f3e55d","#f2e661","#f2e865","#f2ea69","#f1ec6d","#f1ed71","#f1ef75","#f1f179","#f2f27d","#f2f482","#f3f586","#f3f68a","#f4f88e","#f5f992","#f6fa96","#f8fb9a","#f9fc9d","#fafda1","#fcffa4"].reverse()
    // console.log("extent from leg", extentAccess)
    // color scales
    // let legendColor = colorVar==="access"?
    //             scaleQuantize()
    //                     .domain(extentAccess)
    //                     .range(darkMode===true?inferno:schemeBuPu[9])
    //                     // .range(darkMode===true?interpolateInferno:schemeBuPu[9]).nice()
    // :
    //             scaleQuantize()
    //                     .domain(extentPop)
    //                     .range(schemeOranges[9]).nice()

    

    let legendColor = colorVar==="access"?
                scaleSequentialSymlog(t => darkMode===true? interpolateInferno(1 - t): interpolateYlGnBu(1 - t))
                        .domain(extentAccess).nice()
                        // .range(darkMode===true?inferno:schemeBuPu[9])
                        // .range(darkMode===true?interpolateInferno:schemeBuPu[9]).nice()
    :
                scaleQuantize()
                        .domain(extentPop)
                        .range(schemeOranges[9]).nice()
                        
    const n = Math.min(legendColor.domain().length, legendColor.range().length)

    let x = scaleSequentialSymlog()
            .domain(extentAccess)
            .range([0, legendWidth])
    // const x = legendColor.copy().rangeRound(quantize(interpolate(0, legendWidth), n));

    let legendHeight = 15
    let legendTickWidth = legendWidth/numTicks
    let interval = colorVar==="access"?(extentAccess[1] - extentAccess[0])/numTicks:(extentPop[1] - extentPop[0])/numTicks

    // need to keep the legend static if we dont show numbers anyways
    // let legendTicks = colorVar==="access"? range(extentAccess[0],extentAccess[1],interval): range(extentPop[0],extentPop[1],interval)//.reverse()

    let legendTicks = [85, 500, 1000, 2500, accessMax]

    // console.log("legend data", legendTicks)

    function walkingTime(meters, short=false) {
		const km = meters/1000
		const hours = km/5
		const minutes = km/5 * 60
		const seconds = minutes*60
		// return hours or seconds or minutes
		if (short === true) {
			if (minutes<1) {
			return seconds.toFixed() + "sec"
			} else if (minutes>=60){
			return hours.toFixed() + "h"
			} else {
			return minutes.toFixed() + "min"
			}
		} else {
			if (minutes<1) {
			return seconds.toFixed() + " seconds"
			} else if (minutes>60){
			return hours.toFixed() + " hours"
			} else {
			return minutes.toFixed() + " minutes"
			}
		}

		// return `${hours}, ${minutes}, ${seconds}`
	}

    // vars for legend

    function ramp(color, n = 256) {
        const canvas = document.createElement("canvas");
        canvas.width = n;
        canvas.height = 1;
        const context = canvas.getContext("2d");
        for (let i = 0; i < n; ++i) {
            context.fillStyle = color(i / (n - 1));
            context.fillRect(i, 0, 1, 1);
        }
        return canvas;
    }

</script>

<div class="legendContainer">
    <svg width={width} height={legendSvgHeight} display=block margin=auto > 
    <!-- transform={`translate(${margin.left}, 0)`} -->
    <g transform={`translate(${margin.left}, ${margin.top})`}>

    <svg:image
    transform={`translate(0,7)`}
    width={legendWidth}
    height={legendHeight}
    preserveAspectRatio= "none"
    x={0}
    y=0
    xlink:href={ramp(legendColor.copy().domain(quantize(interpolate(0, 1), n))).toDataURL()}/>
        
    {#each legendTicks as data, i}
        <!-- <rect
        transform={`translate(0,7)`}
        width={legendTickWidth}
        height={legendHeight}
        fill={legendColor(data)}
        x={i*legendTickWidth}
        y=0
        >
        </rect> -->

        <!-- stroke="#4d004b"
        stroke-width=1.8px -->
        <!-- <line
        transform={`translate(0,7)`}
        stroke={mainDrawColor}
        stroke-width=1
        x1={i*legendTickWidth}
        y1=0
        x2={i*legendTickWidth}
        y2={legendHeight*1.3}
        >
        </line> -->
    <!-- {#each legendTicks as data, i}
        <text
        transform={data!== 2 * Math.floor(maxStories/2)?`translate(20,0)`:`translate(15,0)`}
        class="legendTicks"
        id="legendLabel"
        color="black"
        x={i*legendTickWidth}
        y={legendHeight*2}
        text-anchor={data!== 2 * Math.floor(maxStories/2)?"middle":"start"}
        >
        {data!== 2 * Math.floor(maxStories/2)?data:data + " Stories"}
        </text>
    {/each} -->
        <text
        transform={`translate(10,2)`}
        class="legendTicks"
        id="legendLabel"
        font-weight=400
        fill={mainDrawColor}
        x={x(data)}
        y={legendHeight*2}
        text-anchor=middle
        >
        {colorVar==="access"?walkingTime(data, true):data}
        </text>

        <!--x={i*legendTickWidth}-->
        <!-- {data===min?"middle":data===2 * Math.floor(max/2)?"start":""} -->
        <!-- {data===min?"Less Stories":data===2 * Math.floor(max/2)?"More Stories":""} -->

        <!-- data.toFixed()+"%" -->
    {/each}
    </g>
    <g transform={`translate(${width/2}, 2)`}>
        <text
        class="legendTicks"
        font-weight=700
        x={0}
        y={margin.top*0.8}
        text-anchor=middle
        fill={mainDrawColor}
        >
        {colorVar==="access"?"Average travel time to services": "Population density"}
        </text>
    </g>
    </svg>
</div>

<style>

.legendTicks {
        /* font-family: 'Roboto', sans-serif; */
        /* font-family: 'DotGothic16', sans-serif; */
        /* font-size: 8px; */
        font-size: calc(8px + 0.15vw);
        /* font-weight: 400; */
        /* fill: black; */
		text-transform: uppercase;
    }

    .legendContainer {
    width:240px;
    /* height:100px; */
    margin:auto;
}

</style>